import React, { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { Spin } from 'antd';

import axios from 'axios';

const OpenSession = () => {
    const auth = useAuth();
    const [subId, setSubId] = useState("");
    const [searchParams] = useSearchParams();
    const [loginInfo, setLoginInfo] = useState(null);

    useEffect(() => {
        var submissionId = searchParams.get('submissionId');

        if (submissionId) {
            auth.clear();
            setLoginInfo(null);
            setSubId(submissionId);

        }

    }, []);

    useEffect(() => {
        if (subId != "")
            setLoginInfo({ "submissionId": subId });
    }, [subId])

    useEffect(() => {
        if (loginInfo) {
            auth.openSession(loginInfo);
        }

    }, [loginInfo]);



    if (auth.sesiune) {
        if (auth.sesiune.isAdmin)
            return <Navigate to="/admin" />;

        return <Navigate to="/" />;
    }



    return <div><Spin /> Se incarca...

    </div>
};

export default OpenSession;
